export const messages = {
  en: {
    reportCustomGroupManage: {
      queryCondition: 'Query Conditions',
      inputGroupId: 'Please enter group ID',
      inputGroupName: 'Please enter group name',
      inputGroupUrl: 'Please enter group URL',
      inputGroupNameRequired: 'Required, please enter group name',
      inputGroupUrlRequired: 'Required, please enter group URL',
      inputDescriptionRequired: 'Required, please enter description',
      query: 'Query',
      reset: 'Reset',
      reportGroupInfo: 'Report Group Information',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      groupId: 'Group ID',
      groupName: 'Group Name',
      groupUrl: 'Group URL',
      description: 'Description',
      operation: 'Operation',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteReportGroup: 'Confirm to delete report group?',
      cancelOperation: 'Cancel',
      confirmDelete: 'Confirm Delete',
      addSuccess: 'Add successfully',
      addFailed: 'Add failed',
      editSuccess: 'Edit successfully',
      editFailed: 'Edit failed',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      groupNameRequired: 'Group name is required',
      groupNameMaxLength: 'Group name cannot exceed 128 characters',
      groupUrlRequired: 'Group URL is required',
      groupUrlMaxLength: 'Group URL cannot exceed 512 characters',
      descriptionRequired: 'Description is required',
      descriptionMaxLength: 'Description cannot exceed 512 characters',
      groupIdRequired: 'Group ID is required',
      save: 'Save',
      cancel: 'Cancel'
    }
  },
  zh: {
    reportCustomGroupManage: {
      queryCondition: '查询条件',
      inputGroupId: '请输入组ID',
      inputGroupName: '请输入组名称',
      inputGroupUrl: '请输入组URL',
      inputGroupNameRequired: '必填，请填写组名称',
      inputGroupUrlRequired: '必填，请填写组URL',
      inputDescriptionRequired: '必填，请填写描述',
      query: '查询',
      reset: '重置',
      reportGroupInfo: '报表组信息',
      add: '添加',
      edit: '修改',
      delete: '删除',
      groupId: '组ID',
      groupName: '组名称',
      groupUrl: '组URL',
      description: '描述',
      operation: '操作',
      confirmOperation: '请确认您的操作',
      confirmDeleteReportGroup: '确定删除报表组?',
      cancelOperation: '点错了',
      confirmDelete: '确认删除',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      groupNameRequired: '组名称不能为空',
      groupNameMaxLength: '组名称不能超过128个字符',
      groupUrlRequired: '组URL不能为空',
      groupUrlMaxLength: '组URL不能超过512个字符',
      descriptionRequired: '描述不能为空',
      descriptionMaxLength: '描述不能超过512个字符',
      groupIdRequired: '组ID不能为空',
      save: '保存',
      cancel: '取消'
    }
  }
}